module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-1.e59522d4.jpg";